<template>
<div class="modal fade bd-example-modal-sm" tabindex="-1" role="dialog" id="modal_default_sm">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body text-center">
                <p class="modal_text">{{ errorMessage }}</p>
                <div class="modal_bottom">
                    <div class="modal_btn_wrapper row justify-content-center">
                        <div class="col-8">
                            <button class="btn primary md" @click="$emit('panel-modal', false)">
                                <span class="btn_text">{{ buttonText }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        props: {
            errorMessage: {
                type: String
            },
            buttonText: {
                type: String
            }
        }
    }
</script>